const feedback = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Feedback",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    info_box: {
                      type: "checkbox",
                      label: "Add Information Box",
                      hideLabel: false,
                      placeholder: "Info Box",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Info Title",
                      placeholder: "Enter Info Title",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    page_title: {
                      type: "text",
                      label: "Page Title",
                      placeholder: "Enter Page Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    // hr2: {
                    //   type: "hr",
                    //   size: "12",
                    // },
                    // feedback: {
                    //   type: "toggle",
                    //   label: "Feedback",
                    //   placeholder: "",
                    //   required: false,
                    //   info: true,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    // feedback_template: {
                    //   type: "select",
                    //   label: "Template",
                    //   placeholder: "Select Template",
                    //   required: false,
                    //   info: false,
                    //   displayOn: "feedback",
                    //   displayOnValue: "true",
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "6",
                    //   style: "",
                    //   options: ["Template A"],
                    // },
                    // hr3: {
                    //   type: "hr",
                    //   size: "12",
                    // },
                    // complaint: {
                    //   type: "toggle",
                    //   label: "Complaint",
                    //   placeholder: "",
                    //   required: false,
                    //   info: true,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    // complaint_template: {
                    //   type: "select",
                    //   label: "Template ",
                    //   placeholder: "Select Template",
                    //   required: false,
                    //   info: false,
                    //   character_count: 0,
                    //   displayOn: "complaint",
                    //   displayOnValue: "true",
                    //   disabled: false,
                    //   class: "",
                    //   size: "6",
                    //   style: "",
                    //   options: ["Template A"],
                    // },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                    fft_reports: {
                      type: "toggle",
                      label: "FFT Reports",
                      placeholder: "Select FFT Reports",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    fft_report_list: {
                      type: "variableList",
                      label: "FFT Reports List",
                      placeholder: "Select",
                      required: false,
                      displayOn: "fft_reports",
                      displayOnValue: "true",
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    result: {
                      type: "toggle",
                      label: "FFT Results",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    fft_chart_option: {
                      type: "select",
                      label: "        ",
                      placeholder: "FFT Results",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "7",
                      style: "",
                      options: ["Pie chart", "Bar chart", "Table", "Donut"],
                      displayOn: "result",
                      displayOnValue: "true",
                    },
                    show_piechart: {
                      type: "checkbox",
                      label: "",
                      hideLabel: false,
                      placeholder: "Pie Chart",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                      displayOn: "result",
                      displayOnValue: "true",
                    },
                    show_table: {
                      type: "checkbox",
                      label: "",
                      hideLabel: false,
                      placeholder: "Table",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                      displayOn: "result",
                      displayOnValue: "true",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Options",
            service: "categoryTypes",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: false,
              addNewSuccessTitle: "Type Added!",
              addNewSuccessMessage: "Type Added Successfully!",
              addNewErrorTitle: "Type Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Type Deleted!",
              deleteSuccessMessage: "Type Deleted Successfully!",
              deleteErrorTitle: "Type Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Type Activated!",
              activeSuccessMessage: "Type Activated Successfully!",
              activeErrorTitle: "Type Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Type Updated!",
              updateSuccessMessage: "Type Updated Successfully!",
              updateErrorTitle: "Type Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Type",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Type",
                    placeholder: "Enter Type",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  nhs_app: true,
                  patient_access: true,
                  systm_online: true,
                  contact_us: true,
                  description: "",
                },
              },
            },
            children: [
              {
                type: "optionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Types",
                  type: "typeList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  rules: {
                    condition: {
                      key: "enable_webform",
                      value: false,
                    },
                    actions: [
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "prescription_request_type",
                        newValue: false,
                      },
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "collection_form",
                        newValue: false,
                      },
                    ],
                  },
                  form: {
                    layout_1: {
                      title: {
                        type: "text",
                        label: "Label",
                        placeholder: "Enter Label",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                      },
                      hr3: {
                        type: "hr",
                        size: "12",
                      },
                      option_type: {
                        type: "select",
                        label: " ",
                        placeholder: "Select Form",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                        options: ["Online Form", "Description"],
                      },
                      option_template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                        options: ["Template A"],
                        displayOn: "option_type",
                        displayOnValue: "Online Form",
                      },
                      option_description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        displayOn: "option_type",
                        displayOnValue: "Description",
                      },
                      "confirmation-message": {
                        type: "ckeditor",
                        label: "Confirmation Message",
                        placeholder: "Confirmation Message",
                        displayOn: "option_type",
                        displayOnValue: "Online Form",
                        required: false,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                      },
                    },
                    layout_2: {
                      title: {
                        type: "text",
                        label: "Label",
                        placeholder: "Enter Label",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                      },
                      option_template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                        options: ["Template A"],
                      },
                    },
                    layout_3: {
                      title: {
                        type: "text",
                        label: "Label",
                        placeholder: "Enter Label",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                      },
                      hr3: {
                        type: "hr",
                        size: "12",
                      },
                      option_type: {
                        type: "select",
                        label: " ",
                        placeholder: "Select Form",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                        options: ["Online Form", "Description"],
                      },
                      option_template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "7",
                        style: "",
                        options: [
                          "Template A",
                          "Template B",
                          "Template C",
                          "Template D",
                          "Template E",
                        ],
                        displayOn: "option_type",
                        displayOnValue: "Online Form",
                      },
                      option_description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        displayOn: "option_type",
                        displayOnValue: "Description",
                      },
                      "confirmation-message": {
                        type: "ckeditor",
                        label: "Confirmation Message",
                        placeholder: "Confirmation Message",
                        displayOn: "option_type",
                        displayOnValue: "Online Form",
                        required: false,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                      },
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                type: "page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  answer: "",
                },
              },
            },
            children: [
              {
                type: "patientGroupTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "list",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Question",
                      placeholder: "Enter Question",
                      required: true,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    answer: {
                      type: "ckeditor",
                      label: "Answer",
                      placeholder: "Enter Answer",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          //   {
          //     title: "Results",
          //     service: "category",
          //     size: "",
          //     style: "",
          //     class: "flex",
          //     children: [
          //       {
          //         type: "descriptionTab",
          //         size: "12",
          //         style: "",
          //         class: "p-0 d-flex",
          //         list: {
          //           type: "list",
          //           size: "4",
          //           style: "",
          //           class: "p-2",
          //           empty: true,
          //           children: [],
          //         },
          //         form: {
          //           type: "form",
          //           variant: "patch",
          //           size: "8",
          //           style:
          //             "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
          //           class: "pl-4 pt-3",
          //           form: {
          //             complaint: {
          //               type: "toggle",
          //               label: "Complaint",
          //               placeholder: "",
          //               required: false,
          //               info: true,
          //               character_count: 0,
          //               disabled: false,
          //               class: "",
          //               size: "12",
          //               style: "",
          //             },
          //             showonwebsite: {
          //               type: "toggle",
          //               label: "Show on website",
          //               placeholder: "",
          //               required: false,
          //               info: true,
          //               character_count: 0,
          //               disabled: false,
          //               class: "",
          //               size: "12",
          //               style: "",
          //             },
          //           },
          //           children: [],
          //         },
          //       },
          //     ],
          //     topbarControls: {
          //       addNewButton: false,
          //       activeToggle: false,
          //       deleteButton: false,
          //       addNewSuccessTitle: "Topic Added!",
          //       addNewSuccessMessage: "Topic Added Successfully!",
          //       addNewErrorTitle: "Topic Creation Failed!",
          //       addNewErrorMessage: "Please try again!",
          //       deleteSuccessTitle: "Topic Deleted!",
          //       deleteSuccessMessage: "Topic Deleted Successfully!",
          //       deleteErrorTitle: "Topic Deletion Failed!",
          //       deleteErrorMessage: "Please try again!",
          //       activeSuccessTitle: "Topic Activated!",
          //       activeSuccessMessage: "Topic Activated Successfully!",
          //       activeErrorTitle: "Topic Activation Failed!",
          //       activeErrorMessage: "Please try again!",
          //       updateSuccessTitle: "Topic Updated!",
          //       updateSuccessMessage: "Topic Updated Successfully!",
          //       updateErrorTitle: "Topic Updation Failed!",
          //       updateErrorMessage: "Please try again!",
          //       addNewModal: {
          //         title: "Add New FAQ",
          //         type: "page",
          //         variant: "add",
          //         submit_url: "/api/categories/$currentCategoryId/pages",
          //         form: {
          //           title: {
          //             type: "text",
          //             label: "Question",
          //             placeholder: "Enter Question",
          //             required: true,
          //             info: true,
          //             character_count: 250,
          //             disabled: false,
          //             class: "",
          //             size: "12",
          //             style: "",
          //           },
          //         },
          //         additionalProps: {
          //           answer: "",
          //         },
          //       },
          //     },
          //   },
        ],
      },
    ],
  },
];

export { feedback };
